export default "__VITE_ASSET__DfUWTFTz__"